import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import ChiSiamo from "@/pages/ChiSiamo";
import News, { NewsArticle } from "@/pages/News";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const LenisRoot = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
};

const AppRoutes = () => (
  <>
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/chi-siamo" element={<ChiSiamo />} />
      <Route path="/adv" element={<ServicePage slug="adv" />} />
      <Route path="/digital" element={<ServicePage slug="digital" />} />
      <Route path="/corporate" element={<ServicePage slug="corporate" />} />
      <Route path="/ai" element={<ServicePage slug="ai" />} />
      <Route path="/video-clip" element={<ServicePage slug="videoclip" />} />
      <Route path="/news" element={<News />} />
      <Route path="/news/:id" element={<NewsArticle />} />
      <Route path="/contatti" element={<Contact />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/cookie-policy" element={<Legal doc="cookies" />} />
      <Route path="*" element={<Home />} />
    </Routes>
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <LenisRoot>
          <ScrollToTop />
          <div className="grain-overlay" aria-hidden="true" />
          <div className="min-h-screen bg-[#08080A] text-slate-50">
            <AppRoutes />
          </div>
          <CookieBanner />
          <ChatWidget />
          <Toaster theme="dark" position="bottom-right" richColors />
        </LenisRoot>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
